export const makeDummyImageUrl = (tags, width = 1200, height = 900, lock = 1) => {
  const tagList = Array.isArray(tags) ? tags.join(',') : String(tags || 'workshop,people,event');
  return `https://loremflickr.com/${width}/${height}/${encodeURIComponent(tagList)}?lock=${lock}`;
};

export const getThemeTagsFromLabel = (label) => {
  const text = String(label || '').toLowerCase();
  if (text.includes('kintsugi')) return ['kintsugi', 'pottery', 'workshop', 'india'];
  if (text.includes('corporate') || text.includes('team') || text.includes('offsite'))
    return ['teamwork', 'workshop', 'people'];
  if (text.includes('group') || text.includes('friends') || text.includes('social') || text.includes('birthday'))
    return ['friends', 'group', 'event'];
  if (text.includes('singles') || text.includes('soir')) return ['people', 'party', 'event'];
  if (text.includes('pottery')) return ['pottery', 'workshop', 'people'];
  if (text.includes('candle')) return ['candle', 'workshop', 'people'];
  if (
    text.includes('sushi') ||
    text.includes('culinary') ||
    text.includes('wine') ||
    text.includes('chocolate') ||
    text.includes('dimsum') ||
    text.includes('mixology') ||
    text.includes('matcha')
  )
    return ['cooking', 'workshop', 'people'];
  if (text.includes('art') || text.includes('canvas') || text.includes('paint')) return ['painting', 'workshop', 'people'];
  return ['workshop', 'people', 'event'];
};

export const getThemeTagsForImage = (img, label) => {
  const customTheme = (img?.dataset?.imageTheme || '').trim();
  if (customTheme) {
    return customTheme
      .split(',')
      .map((tag) => tag.trim())
      .filter(Boolean);
  }
  return getThemeTagsFromLabel(label);
};

export const applyPlaceholderImages = () => {
  if (typeof document === 'undefined') return;
  const imgs = Array.from(document.querySelectorAll('img'));
  imgs.forEach((img, index) => {
    if (img.dataset.keepImage === 'true') return;
    const attrSrc = (img.getAttribute('src') || '').trim();
    // Do not replace logos / files from `public/` (root-relative paths like /assets/...)
    if (attrSrc.startsWith('/') && !attrSrc.startsWith('//')) return;
    const label = (img.alt || `image-${index + 1}`).trim();
    img.src = makeDummyImageUrl(getThemeTagsForImage(img, label), 1200, 900, index + 1);
  });

  const serviceItems = Array.from(document.querySelectorAll('.service-item'));
  serviceItems.forEach((item, index) => {
    const label = (item.dataset.title || `service-${index + 1}`).trim();
    item.dataset.image = makeDummyImageUrl(getThemeTagsFromLabel(label), 1400, 900, index + 101);
  });
};

export const applyPolaroidLayout = (cards) => {
  if (!cards) return;
  cards.forEach((card, index) => {
    const rotation = Math.random() * 28 - 14;
    const x = Math.random() * 190 - 95;
    const y = Math.random() * 130 - 65;
    const zIndex = index + 1;
    card.style.zIndex = String(zIndex);
    card.style.transform = `translate(-50%, -50%) translate(${x}px, ${y}px) rotate(${rotation}deg)`;
  });
};
